import { render, staticRenderFns } from "./CreateUnit.vue?vue&type=template&id=518fc7de&scoped=true&"
import script from "./CreateUnit.vue?vue&type=script&lang=js&"
export * from "./CreateUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518fc7de",
  null
  
)

export default component.exports